import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { WrappedFormUtilsExtended } from 'Helpers'

type FormsState = {
	forms: Map<string, WrappedFormUtilsExtended>
}

export const formsInitialState: FormsState = {
	forms: new Map(),
}

export namespace FormsNS {
	export type AddForm = PayloadAction<{ key: string; form: any }>
	export type RemoveForm = PayloadAction<string>
}

export const formsSlice = createSlice({
	name: 'forms',
	initialState: formsInitialState,
	reducers: {
		addForm: (state, action: FormsNS.AddForm) => {
			const { key, form } = action.payload
			state.forms.set(key, form)
		},
		removeForm: (state, action: FormsNS.RemoveForm) => {
			state.forms.delete(action.payload)
		},
	},
})
